module.exports = __webpack_public_path__ + "static/media/pp.41fe9b5f.jpeg";